import Vue from 'vue'
import Vuex from 'vuex'

import Auth from '@/Warehouse/Auth'

Vue.use(Vuex)

export default new Vuex.Store({
  modules:{
    Auth
  },
  state: {

  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },

})
